import { HttpErrorResponse } from '@angular/common/http'
import { ErrorHandler, Injectable } from '@angular/core'
import { environment } from '../../environments/environment'

@Injectable()
export class GestorDeErros implements ErrorHandler {
    constructor() {}

    tratarErro(erro: any) {
        if (erro instanceof HttpErrorResponse) {
            this.tratarHttpResponseError(erro)
        }

        throw erro
    }

    handleError(error: any) {
        this.tratarErro(error)
    }

    tratarHttpResponseError(erro: HttpErrorResponse) {
        switch (erro.status) {
            case 401:
                this.tratarUsuarioNaoAutenticado()
                break

            case 403:
                this.tratarUsuarioSemCollect()
                break
        }
    }

    tratarUsuarioSemCollect() {
        window.location.assign(environment.packupBaseUrl)
    }

    tratarUsuarioNaoAutenticado() {
        window.location.assign(environment.packupBaseUrl)
    }
}



// WEBPACK FOOTER //
// ./src/app/core/gestor-de-erros.ts